import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { useLocation } from '@reach/router';
import { parseLanguageFromPathName } from '../../util/language-util'
import React from 'react'
import * as classes from './nav-header-left.module.css'

const NavHeaderLeft: React.FC = () => {
  try {
    const location = useLocation();
    const parsedLanguage = parseLanguageFromPathName(location.pathname)
    return (
      <Link to='/' className={classes.container}>
        <StaticImage 
          src={'../../assets/images/logo-symbol.png'} 
          className={classes.logoIcon} 
          alt={'energy routine logo'}
        />
        <p className={classes.logoText}>
          { 
            parsedLanguage == 'ko'
            ? '달비트'
            : 'DaarBit'
          }
        </p>
      </Link>
    )
  } catch (e) {return null}
}

export default NavHeaderLeft;